import React from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { IS_PROD, SENTRY_DSN } from "@/utilities/configurations";
import { version } from "$root/package.json";

Sentry.init({
  fetchParameters: { keepalive: false },
  dsn: SENTRY_DSN,
  autoSessionTracking: true,
  release: `opticks-panel@${version}`,
  tracesSampleRate: 0.2,
  environment: IS_PROD === "true" ? "production" : "development",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  ignoreErrors: [
    "Could not mount master component",
    "Request interrupted by user",
    "Request aborted",
    "ERR_CANCELED",
    "timeout of",
    "timeout exceeded",
    "Network Error",
    /cancelled/i,
    /aborted/i,
  ],
  ignoreUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
  ],
  beforeSend(event, hint) {
    if (window.navigator.userAgent.includes("; wv)")) {
      return null;
    }

    // Filter out cancelled/aborted requests
    const error = hint?.originalException;
    if (error && typeof error === "object") {
      const errorMessage = (error as any)?.message || "";
      const errorCode = (error as any)?.code || "";

      // Ignore cancelled/aborted/timeout/network errors
      if (
        errorCode === "ERR_CANCELED" ||
        errorCode === "ECONNABORTED" ||
        errorCode === "ERR_NETWORK" ||
        errorMessage.includes("Request interrupted") ||
        errorMessage.includes("Request aborted") ||
        errorMessage.includes("cancelled") ||
        errorMessage.includes("aborted") ||
        errorMessage.includes("timeout") ||
        errorMessage.includes("Network Error")
      ) {
        return null;
      }
    }

    return event;
  },
  enabled: IS_PROD === "true",
} as Sentry.BrowserOptions);

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
